
import { mapGetters, mapState } from 'vuex';
import FButton from '@/components/atoms/buttons/h-button';
import FIcon from '@/components/atoms/icons/h-icon';
import StickyContainer from '@/components/molecules/sticky-cta/sticky-container';

import AdvancedInputsForm from '@/ui/retirement-calculator/advanced-inputs-form';
import HousingForm from '@/ui/retirement-calculator/housing-form';
import PersonalForm from '@/ui/retirement-calculator/personal-form';

export default {
  name: 'DialogCentered',

  components: {
    AdvancedInputsForm,
    FButton,
    FIcon,
    HousingForm,
    PersonalForm,
    StickyContainer,
  },

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 668,
    },
    header: {
      type: String,
      default: '',
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      tab: null,
      dialog: this.isShown,
    };
  },

  computed: {
    ...mapGetters({
      hasFormErrors: 'pension-calculator/hasFormErrors',
    }),

    ...mapState({
      isFormFocused: (state) => state['pension-calculator'].isFormFocused,
    }),

    tabNames() {
      return Object.values(this.$t('tabs'));
    },
    tabObjects() {
      return this.tabNames.map((name, index) => ({
        name,
        icon: index === 1 ? 'filters' : 'funnel',
      }));
    },
  },

  watch: {
    isShown(value) {
      this.dialog = value;
    },
  },

  methods: {
    async handleTabClick(name) {
      if (name === this.$t('tabs.advanced')) {
        await this.$eventTrackClick(
          'Website Pension Calculator Advanced Inputs Link',
        );
      }
    },
  },
};
